import { Injectable } from '@angular/core';
import * as SockJs from 'sockjs-client';
import * as Stomp from 'stompjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { KeycloakService } from '../auth/keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private stompClient: any;
  private messageSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public message$ = this.messageSubject.asObservable();
  private url: string = environment.BACKEND_RACINE_URL;
  constructor(private keycloakService: KeycloakService) {
    this.connect(); // Connecter automatiquement lors de l'initialisation du service
  }

  // Initialiser la connexion WebSocket
  connect() {
    const socket =  new SockJs(`${this.url}ws/`); // Changez l'URL selon votre serveur WebSocket
    this.stompClient = Stomp.over(socket);
    let token = this.keycloakService.getToken();
    const userLogin = this.keycloakService.getUsername();
    this.stompClient.connect({'Authorization': 'Bearer ' + token}, (frame: any) => {
        console.log('WebSocket connected!');

      // S'abonner aux événements
      this.stompClient.subscribe('/topic/events', (message: any) => {
        this.messageSubject.next(JSON.parse(message.body));
      });

      // S'abonner aux événements spécifiques à l'utilisateur (ex. /user/{userId})
      this.stompClient.subscribe(`/user/${userLogin}/events/notification`, (message: any) => {
        this.messageSubject.next(JSON.parse(message.body));
      });

      // S'abonner aux messages topic spécifique d'utilisateurs
      //TODO: Remplacer par les utilisateurs connectés

    }, (error: any) => {
      console.error('Error during connection: ', error);
    });
  }

  // Méthode pour fermer la connexion
  public disconnect() {
    if (!this.stompClient) {
      return;
    }
    try {
      // Avoid InvalidStateError when SockJS is still connecting
      if (this.stompClient.connected) {
        this.stompClient.disconnect(() => {
          console.log('WebSocket disconnected.');
        });
      } else if (this.stompClient.ws) {
        this.stompClient.ws.close();
      }
    } catch (error) {
      console.warn('Error while disconnecting WebSocket:', error);
    } finally {
      this.stompClient = null;
    }
  }

  // Méthode pour envoyer des messages, si nécessaire
  public sendMessage(destination: string, body: any) {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.send(destination, {}, JSON.stringify(body));
    }
  }


}
